export const COLLECT_INFO_FORM = {
  root: 'collect-info-form',
  continue: 'collect-info-continue',
  checkoutGuest: 'checkout-as-guest',
  phone: 'collect-info-phone',
  email: 'collect-info-email',
  switch: 'collect-info-switch',
  clearState: 'collect-clear',
  id: 'collect-info-id'
};
